export default "<app-manage-all-codes \n[headderText] = \"'Manage PromoAmount'\"\n[isPromo] = \"true\">\n</app-manage-all-codes>";